import { cn } from "@gettactic/helpers";
import React from "react";
import { LucideIcon } from "../../icons";
import { Flex } from "../../primitives";
import { FormControlSlot } from "./FormControlSlot";
import { useFormControlWrapper } from "./FormControlWrapperProvider";
import { FormControlWrapperProps } from "./defines";
import { IconName } from "@cmp-src/primitives/Icon/Icon.types";

interface FormControlWrapperContentProps extends FormControlWrapperProps {
  slotFocusHandler?: (event: React.MouseEvent) => void;
}

export const FormControlWrapperContent: React.FC<
  FormControlWrapperContentProps
> = (props) => {
  const {
    leftSlot,
    rightSlot,
    leftIcon,
    rightIcon,
    children,
    slotFocusHandler
  } = props;
  const { isInvalid } = useFormControlWrapper();

  const iconClassNames = React.useMemo(
    () => cn("w-4", isInvalid ? "text-red-700" : "text-muted-foreground"),
    [isInvalid]
  );

  return (
    <>
      {(leftIcon || (Array.isArray(leftSlot) && leftSlot.length > 0)) && (
        <Flex className={"items-center mr-1"}>
          {leftIcon && (
            <FormControlSlot onMouseDown={slotFocusHandler}>
              {typeof leftIcon === "string" ? (
                <LucideIcon
                  className={iconClassNames}
                  name={leftIcon as IconName}
                />
              ) : (
                leftIcon
              )}
            </FormControlSlot>
          )}
          {Array.isArray(leftSlot) &&
            leftSlot.map((slot, index) => (
              <FormControlSlot key={String(index)}>{slot}</FormControlSlot>
            ))}
        </Flex>
      )}
      {children}
      {(rightIcon || (Array.isArray(rightSlot) && rightSlot.length > 0)) && (
        <Flex className={"items-center gap-2"}>
          {Array.isArray(rightSlot) &&
            rightSlot.map((slot, index) => (
              <FormControlSlot key={String(index)}>{slot}</FormControlSlot>
            ))}
          {rightIcon && (
            <FormControlSlot onMouseDown={slotFocusHandler}>
              {typeof rightIcon === "string" ? (
                <LucideIcon
                  className={iconClassNames}
                  name={rightIcon as IconName}
                />
              ) : (
                rightIcon
              )}
            </FormControlSlot>
          )}
        </Flex>
      )}
    </>
  );
};
